export default function (value, length) {
    if(value.length < length) {
        return value;
    }
    length = length - 3;
    return value.substring(0, length) + '...';
}


// WEBPACK FOOTER //
// ./src/filters/ellipsis.js